const getters = {
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    activeMenu: state => state.sysData.activeMenu,
    position: state => state.sysData.position,
}
export default getters